import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import index from "./store";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/styles.css";
import "./styles/home-course-titles.css";
import "./styles/course-day-sidebar.css";
import "./styles/course-hero-layout.css";
import "./styles/course-modal-accessibility.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Provider store={index}>
		<App />
	</Provider>
);
